export default __webpack_public_path__ + "static/media/vector.cb8d23fa.svg";